module.exports = __webpack_public_path__ + "assets/img/kv-38f88256.jpg";